export const SERVER_MAX_TAKE = 150;
